const routes = {
  purchaseOrderStatus: '/estado-orden-compra/:purchaseOrderCode',
  quoteProvidersList: '/agregar-proveedores',
  quoteStepOne: '/cotizacion-paso-uno',
  quoteStepTwo: '/cotizacion-paso-dos',
  quoteStepTwoAddProducts: '/agregar-productos-servicios',
  quoteRequestPublishedSuccessfully: '/solicitud-cotizacion-publicada',
  quoteSellerBid: '/oferta-cotizacion/:quoteId',
  root: '/',
  search: '/buscador',
  searchGoodsAndServices: '/buscador-productos-servicios',
  sellerQuotePublishedSuccessfully: '/cotizacion-publicada',
  quoteSummary: '/resumen-cotizacion/:quoteId'
}

export default routes
